import BaseService from './base.service';

class ObservationsReportService extends BaseService {
  async getObservationSummary(params = {}) {
    const queryString = this.getQueryString(params);
    return this.get(`/observations-reports/observations-statistics${queryString}`);
  }

  async getTechnologistSummary(params = {}) {
    const queryString = this.getQueryString(params);
    return this.get(`/observations-reports/technologist-summary${queryString}`);
  }

  async getTechnologistDistribution(params = {}) {
    const queryString = this.getQueryString(params);
    return this.get(`/observations-reports/technologist-distribution${queryString}`);
  }

  async getTechnologistComparison(params = {}) {
    const queryString = this.getQueryString(params);
    return this.get(`/observations-reports/technologist-comparison${queryString}`);
  }

  async getFacilityComparison(params = {}) {
    const queryString = this.getQueryString(params);
    return this.get(`/observations-reports/facility-comparison${queryString}`);
  }
}

export default ObservationsReportService;
